import React from 'react';
import { AttachmentReportOptionsCell } from '../components/AttachmentReportOptionsCell';
import { AttachmentResultCell } from '../components/AttachmentResultCell';
import { AttachmentTextFieldCell } from '../components/AttachmentTextFieldCell';
/**
 * `dataKey`s these columns sort on, handed to the surface as `entitySortableColumns`.
 *
 * `reportOptionsSortKey` rather than the summary string, for the same reason Building sorts
 * `Visible to` on a numeric key: the display text sorts alphabetically, which is meaningless.
 */
export const INSPECTION_SORTABLE_COLUMNS = [
    'technicianName',
    'certificationNumber',
    'resultLabel',
    'reportOptionsSortKey'
];
/**
 * Inspection's own four columns — Technician, Certification #, Result and Report options —
 * inserted by the shared surface between Name and Type. Everything else in that table (preview,
 * name, type, uploaded, size, delete) is the surface's and is identical across every attachment
 * screen.
 */
export function buildInspectionColumns({ translateFn, inspectionId, hasCoverLetter }) {
    return [
        {
            dataKey: 'technicianName',
            label: translateFn('columns.technician'),
            width: '170px',
            renderer: ({ item }) => (React.createElement(AttachmentTextFieldCell, { item: item, inspectionId: inspectionId, field: "technicianName", placeholder: translateFn('placeholders.technician') }))
        },
        {
            dataKey: 'certificationNumber',
            label: translateFn('columns.certification_number'),
            width: '160px',
            renderer: ({ item }) => (React.createElement(AttachmentTextFieldCell, { item: item, inspectionId: inspectionId, field: "certificationNumber", placeholder: translateFn('placeholders.certification_number') }))
        },
        {
            dataKey: 'resultLabel',
            label: translateFn('columns.result'),
            width: '130px',
            renderer: ({ item }) => (React.createElement(AttachmentResultCell, { item: item, inspectionId: inspectionId, translateFn: translateFn }))
        },
        {
            dataKey: 'reportOptionsSortKey',
            label: translateFn('columns.report_options'),
            width: '200px',
            renderer: ({ item }) => (React.createElement(AttachmentReportOptionsCell, { item: item, inspectionId: inspectionId, translateFn: translateFn, hasCoverLetter: hasCoverLetter }))
        }
    ];
}
